<section class="py-14 md:py-24">
  <div class="max-w-[1120px] mx-auto text-center">
    <div
      class="inline-flex items-center gap-2 bg-[rgba(76,234,99,0.08)] px-3.5 py-1.5 rounded-full mb-5"
      data-aos="fade-up"
    >
      <span class="relative flex h-[5px] w-[5px]">
        <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4CEA63] opacity-75"></span>
        <span class="relative inline-flex rounded-full h-[5px] w-[5px] bg-[#4CEA63]"></span>
      </span>
      <span
        class="text-[11px] font-bold tracking-[1.5px] uppercase text-[#4CEA63]"
      >
        {{ "talentSearchV2.pricing.badge" | translate }}
      </span>
    </div>

    <h2
      data-aos="fade-up"
      class="text-[28px] md:text-[40px] font-[800] leading-[1.35] tracking-[-1.2px] text-white mb-3"
      [innerHTML]="'talentSearchV2.pricing.title' | translate | accent">
    </h2>

    <p data-aos="fade-up" class="text-[17px] text-white/50 leading-[1.8]">
      {{ "talentSearchV2.pricing.subtitle" | translate }}
    </p>

    <!-- Loading state -->
    <ng-container *ngIf="plansQuery.result$ | async as result">
      <ng-container *ngIf="result.isLoading">
        <div class="flex justify-center mb-12">
          <div class="h-12 w-80 bg-white/10 rounded-2xl animate-pulse"></div>
        </div>
        <div
          class="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-[880px] mx-auto"
        >
          <div
            class="pricing-card h-[500px] animate-pulse"
            *ngFor="let i of [1, 2]"
          >
            <div class="h-6 w-32 bg-white/10 rounded-full mb-5"></div>
            <div class="h-5 w-40 bg-white/10 rounded mb-2"></div>
            <div class="h-4 w-full bg-white/5 rounded mb-8"></div>
            <div class="h-20 w-full bg-white/5 rounded-2xl mb-6"></div>
            <div
              class="h-4 w-full bg-white/5 rounded mb-3"
              *ngFor="let j of [1, 2, 3, 4]"
            ></div>
          </div>
        </div>
      </ng-container>

      <!-- Plans loaded -->
      <ng-container *ngIf="result.isSuccess && plans.length">
        <!-- Period toggles -->
        <div id="pricing" class="py-12">
        <!-- Desktop toggle -->
        <div class="hidden sm:flex justify-center" data-aos="fade-up">
          <div class="period-toggle">
            <button
              *ngFor="let duration of availableDurations"
              class="ptab"
              [class.on]="selectedPeriod === duration"
              (click)="selectPeriod(duration)"
            >
              {{ getDurationLabel(duration) | translate }}
              <span
                class="ptab-save"
                *ngIf="getSavingsForDuration(duration) as savings"
              >
                -{{ savings }}%
              </span>
            </button>
          </div>
        </div>

        <!-- Mobile dropdown -->
        <div class="sm:hidden flex justify-center" data-aos="fade-up">
          <button
            [matMenuTriggerFor]="periodMenu"
            class="inline-flex items-center gap-2 bg-white/10 rounded-full px-6 py-3 font-semibold text-base text-white border border-white/10 cursor-pointer"
          >
            {{ getDurationLabel(selectedPeriod) | translate }}
            <mat-icon class="!text-[18px]">expand_more</mat-icon>
          </button>

          <mat-menu #periodMenu>
            <button
              mat-menu-item
              *ngFor="let duration of availableDurations"
              (click)="selectPeriod(duration)"
            >
              {{ getDurationLabel(duration) | translate }}
            </button>
          </mat-menu>
        </div>
        </div>

        <!-- Plan cards -->
        <div
          class="grid grid-cols-1 sm:grid-cols-2 gap-5 max-w-[880px] mx-auto"
        >
          <div
            class="pricing-card"
            [class.pricing-card--featured]="planCards[plan.type].highlighted"
            *ngFor="let plan of plans"
            data-aos="fade-up"
          >
            <!-- Plan tag -->
            <div
              class="plan-tag"
              [class.ptag-pro]="!planCards[plan.type].highlighted"
              [class.ptag-exec]="planCards[plan.type].highlighted"
            >
              {{
                planCards[plan.type].highlighted
                  ? ("talentSearchV2.pricing.plans.executive.tag" | translate)
                  : ("talentSearchV2.pricing.plans.professional.tag"
                    | translate)
              }}
            </div>

            <!-- Plan name -->
            <h3
              class="text-[22px] leading-[36px] font-[800] mb-1.5"
              [class.text-white]="planCards[plan.type].highlighted"
              [class.text-[#061430]]="!planCards[plan.type].highlighted"
            >
              {{ planCards[plan.type].nameKey | translate }}
            </h3>

            <!-- Plan description -->
            <p
              class="text-[14px] leading-[22px] font-normal mb-6 min-h-[38px]"
              [class.text-[#FFFFFF73]]="planCards[plan.type].highlighted"
              [class.text-[#3B4A6B]]="!planCards[plan.type].highlighted"
            >
              {{ planCards[plan.type].descKey | translate }}
            </p>

            <!-- Price area -->
            <div
              class="price-area"
              [class.price-area--featured]="planCards[plan.type].highlighted"
              *ngIf="getCurrentPrice(plan) as price"
            >
              <div>
                <div class="flex items-baseline gap-1">
                  <mat-icon
                    svgIcon="sar"
                    class="!w-[18px] !h-[22px] self-start mt-2.5"
                    [class.text-white]="planCards[plan.type].highlighted"
                    [class.text-[#838A98]]="!planCards[plan.type].highlighted"
                  >
                  </mat-icon>
                  <span
                    class="text-[40px] font-[700] tracking-[-2px] leading-[40px]"
                    [class.text-white]="planCards[plan.type].highlighted"
                    [class.text-[#061430]]="!planCards[plan.type].highlighted"
                  >
                    {{ formatPrice(price.price_per_month) }}
                  </span>
                  <span
                    class="text-[14px] font-bold"
                    [class.text-[#CACFD8]]="planCards[plan.type].highlighted"
                    [class.text-[#838A98]]="!planCards[plan.type].highlighted"
                  >
                    {{ planCards[plan.type].periodKey | translate }}
                  </span>
                </div>
                <div
                  class="text-[12px] leading-[16px] mt-1"
                  [class.text-[#FFFFFF40]]="planCards[plan.type].highlighted"
                  [class.text-[#838A98]]="!planCards[plan.type].highlighted"
                >
                  {{ getBilledNoteKey(plan.type) | translate }}
                </div>
              </div>
              <span
                *ngIf="price.savings_percentage"
                class="psave"
                [class.psave-pro]="!planCards[plan.type].highlighted"
                [class.psave-exec]="planCards[plan.type].highlighted"
              >
                {{ "talentSearchV2.pricing.save" | translate }}
                {{ price.savings_percentage }}%
              </span>
            </div>

            <!-- Divider -->
            <div
              class="h-px mb-5"
              [class.bg-[rgba(255,255,255,0.1)]]="
                planCards[plan.type].highlighted
              "
              [class.bg-[rgba(6,20,48,0.09)]]="
                !planCards[plan.type].highlighted
              "
            ></div>

            <!-- Features label -->
            <div
              class="text-[14px] leading-[20px] font-normal mb-3 uppercase tracking-[1px]"
              [class.text-[#FFFFFF47]]="planCards[plan.type].highlighted"
              [class.text-[#838A98]]="!planCards[plan.type].highlighted"
            >
              {{ planCards[plan.type].includesKey | translate }}
            </div>

            <!-- Features list -->
            <ul class="list-none p-0 m-0 mb-7 flex-1 flex flex-col gap-2.5">
              <li
                *ngFor="let feature of planCards[plan.type].featuresKeys; let i = index"
                class="flex items-start gap-2.5 text-[13px] leading-[1.5]"
                [class.text-[#FFFFFFA6]]="planCards[plan.type].highlighted"
                [class.text-[#3B4A6B]]="!planCards[plan.type].highlighted"
                [class.font-extrabold]="i === planCards[plan.type].boldIndex"
              >
                <span
                  class="w-[18px] h-[18px] rounded-full flex items-center justify-center shrink-0 mt-px"
                  [class.bg-[rgba(76,234,99,0.2)]]="
                    planCards[plan.type].highlighted
                  "
                  [class.bg-[rgba(53,60,216,0.1)]]="
                    !planCards[plan.type].highlighted
                  "
                >
                  <span class="inline-grid place-items-center rounded-full w-[18px] h-[18px]"
                        [class.bg-[#4CEA6333]]="planCards[plan.type].highlighted"
                        [class.bg-[#353CD81A]]="!planCards[plan.type].highlighted"
                  >
                    <app-icon
                      name="check"
                      [size]="12"
                      [class.text-[#4CEA63]]="planCards[plan.type].highlighted"
                      [class.text-[#353CD8]]="!planCards[plan.type].highlighted"
                    />
                  </span>

                  <!--                  <svg width="10" height="10" viewBox="0 0 12 12" fill="none">-->
                  <!--                    <path-->
                  <!--                      d="M2 6l3 3 5-5"-->
                  <!--                      [attr.stroke]="-->
                  <!--                        planCards[plan.type].highlighted ? '#4CEA63' : '#353CD8'-->
                  <!--                      "-->
                  <!--                      stroke-width="2"-->
                  <!--                      stroke-linecap="round"-->
                  <!--                      stroke-linejoin="round"-->
                  <!--                    />-->
                  <!--                  </svg>-->
                </span>
                {{ feature | translate }}
              </li>
            </ul>

            <!-- CTA -->
            <a
              [href]="getStartedUrl(plan)"
              class="plan-cta"
              [class.cta-pro]="!planCards[plan.type].highlighted"
              [class.cta-exec]="planCards[plan.type].highlighted"
            >
              {{ planCards[plan.type].ctaKey | translate }}
              <span class="inline-grid place-items-center rtl:flip"><app-icon name="tabler:arrow-narrow-right" [size]="18" /></span>
            </a>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</section>
